import Collection from '@/components/Collection';
import View from '@/pages/event/Detail';
import access from '../access';

export default {

  'event.collection':{
    path: '/admin/events',
    name: 'event.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listEvents",
      entity: "event",
      cols: [
        {label: "Sequence", sort: "sequence", field: "sequence"},
        {label: "Domain", sort: "domain", field: "domain" },
        {label: "Aggregate Type", sort: "aggregate_type", field: "aggregate_type" },
        {label: "Aggregate ID", uuid: "aggregate_id" },
        {label: "Aggregate Version", field: "aggregate_version" },
        {label: "Event", sort: "event", field: "event" },
        {label: "Correlation", sort: "correlation", uuid: "correlation" },
        {
          label: "Changes",
          component: "ModalDetail",
          componentProps: (row) => {
            return {
              title: "Changes",
              severity: "warning",
              payload: '<pre>'+JSON.stringify(JSON.parse(row.changes), null, 2)+'</pre>'
            }
          }
        },
      ],
      actions: (rec) => {
        return [
          { name: "event.view", label: "history", icon: "history", params: {domain: rec.domain, type: rec.aggregate_type, id: rec.aggregate_id, version: rec.aggregate_version} },
        ];
      }
    },
    meta: {
      access: access.admin,
      title: "Events",
      side_menu: { label: "System changes",  icon: "stack", weight: 200 },
    },
  },

  'event.view': {
    path: '/admin/events/view/:domain/:type/:id/:version',
    name: 'event.view',
    component: View,
    props: true,
    meta: {
      access: access.admin,
      title: "Event details",
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/events.js